module.exports = __webpack_public_path__ + "assets/img/region.73c8a73a.svg";